/**
 * Reusable Handles Finish Fields Component
 * Used in both project wizard and element forms
 * Handles model and color selection
 */

import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'

interface HandlesFinishFieldsProps {
  // Model
  model?: string
  onModelChange: (model: string) => void
  
  // Color
  color?: string
  onColorChange: (color: string) => void
}

export function HandlesFinishFields({
  model = '',
  onModelChange,
  color = '',
  onColorChange,
}: HandlesFinishFieldsProps) {
  return (
    <div className="space-y-4">
      {/* Model */}
      <div className="space-y-2">
        <Label>Modèle poignée *</Label>
        <Input
          value={model}
          onChange={(e) => onModelChange(e.target.value)}
          placeholder="Ex: Barre inox, Bouton rond..."
        />
      </div>

      {/* Color */}
      <div className="space-y-2">
        <Label>Coloris *</Label>
        <Input
          value={color}
          onChange={(e) => onColorChange(e.target.value)}
          placeholder="Ex: Inox brossé, Noir mat..."
        />
      </div>
    </div>
  )
}
